import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { CircularProgress } from '@eruvaka/web-pondlogs-base';
// Check if user has any locations (farms) set up
const useLocationCount = () => {
    const [locationCount, setLocationCount] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        const checkLocations = async () => {
            try {
                const { fetchLocations } = await import('@eruvaka/web-pondlogs-ponds');
                const locations = await fetchLocations();
                setLocationCount(locations.length);
            }
            catch (error) {
                console.error('Failed to fetch locations:', error);
                // On error, default to 0 to show the ponds setup page
                setLocationCount(0);
            }
            finally {
                setIsLoading(false);
            }
        };
        checkLocations();
    }, []);
    return { locationCount, isLoading };
};
export const PondCheckRedirect = () => {
    const { locationCount, isLoading } = useLocationCount();
    if (isLoading) {
        return _jsx(CircularProgress, {});
    }
    // New user with no locations: go to ponds page (shows LandingPage inline)
    if (locationCount === 0) {
        return _jsx(Navigate, { to: "/ponds", replace: true });
    }
    // Existing user with locations: go to dashboard
    return _jsx(Navigate, { to: "/landing", replace: true });
};
